var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-popover',{attrs:{"placement":"top-start","popoverClass":"reset-credenziali-servizio"}},[_c('span',{staticClass:"info tooltip-target b3",attrs:{"data-campo":_vm.campo}},[_vm._v("?")]),_c('template',{slot:"popover"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.msg)}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }